export class AssetCheckinDto {
    public Id: number
    public CreatedBy: string
    public CreatedOn: Date
    public PersonCompanyName: string
    public ContractNumber: string
    public CheckedOutOn?: Date
    public CheckedInOn?: Date
    public Note: string
}